import { createStore } from 'vuex'
import user  from './modules/user'

export default createStore({
  state: {
    token: localStorage.getItem('token') || '',
    //user: null,
    isMenuCollapsed: false
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    clearToken(state) {
      state.token = ''
      localStorage.removeItem('token')
    },
    toggleMenu(state) {
      state.isMenuCollapsed = !state.isMenuCollapsed
    }
  },
  actions: {
    login({ commit }, credentials) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const token = 'mock-token-' + credentials.username
          commit('setToken', token)
          commit('setUser', { username: credentials.username })
          resolve()
        }, 500)
      })
    },
    logout({ commit }) {
      commit('clearToken')
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    currentUser: state => state.user
  },
  modules: {
    user
  }
})